import React from 'react';
import { Box, Button, Card, Fade, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export default function ExpandableCard(props: {
  children: React.ReactNode;
  title: string;
  initiallyOpen?: boolean;
  onChange?: (nextState: boolean) => void;
  smallMargin?: boolean;
}) {
  const [open, setOpen] = React.useState(props.initiallyOpen ? true : false);

  return (
    <Grid item xs={12}>
      <Box display="flex" flexDirection="column" rowGap={1}>
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
          columnGap={1}
        >
          <Button
            variant="text"
            sx={{ m: 0, p: 0, minWidth: 0 }}
            size="small"
            onClick={() => {
              if (props.onChange) {
                props.onChange(!open);
              }
              setOpen(!open);
            }}
          >
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Button>
          <Typography variant="h6">{props.title}</Typography>
        </Box>
        <Fade in={open}>
          <Card
            sx={{
              p: props.smallMargin ? 2 : 4,
              display: !open ? 'none' : 'inline-block',
            }}
            elevation={1}
          >
            <Box display="flex" flexDirection="column" rowGap={2}>
              {props.children}
            </Box>
          </Card>
        </Fade>
      </Box>
    </Grid>
  );
}
